import { jsx as s } from "react/jsx-runtime";
import { Root as v, Thumb as N } from "@radix-ui/react-switch";
import c from "classnames";
import { forwardRef as d, useCallback as D } from "react";
import K from "./index.es2499.js";
import x from "./index.es2500.js";
import i from "./index.es2501.js";
import { onKeyDownEnterAndSpace as O } from "./index.es526.js";
const V = d(
  ({ onCheckedChange: t, defaultChecked: l, testId: m, theme: o, checked: f = !1, disabled: a, ...p }, w) => {
    const r = f || l, n = c(
      {
        [i.checked]: r,
        [i.disabled]: a
      },
      r && o.checked,
      a && o.disabled
    ), u = c(i.container, o.container, n), y = c(i.switch, o.switch, n), S = c(i.thumb, o.thumb, n), b = D(
      (e) => {
        O(
          e,
          () => {
            t == null || t(!r);
          },
          !0,
          !1
        );
      },
      [t, r]
    );
    return /* @__PURE__ */ s("div", { className: u, "data-testid": `${m}-container`, children: /* @__PURE__ */ s(
      v,
      {
        ref: w,
        className: y,
        checked: f,
        disabled: a,
        "data-testid": m,
        onKeyDown: b,
        onCheckedChange: t,
        defaultChecked: l,
        "aria-label": "switch",
        ...p,
        children: /* @__PURE__ */ s(N, { className: S, "data-testid": `${m}-thumb`, children: r ? /* @__PURE__ */ s(x, {}) : /* @__PURE__ */ s(K, {}) })
      }
    ) });
  }
);
export {
  V as SwitchPrimitive
};
//# sourceMappingURL=index.es665.js.map
